import { constants } from '@bedc/constants';

import { Request as BaseRequest } from '../../../generic/search/Request';

export const Request = BaseRequest({
	sortFields: constants.wholeHouse.materialTemplate.sortFields,
	columnFields: constants.wholeHouse.materialTemplate.columnFields,
	standardFilterFields: constants.wholeHouse.materialTemplate.osStandardFilterFields,
	dateFilterFields: constants.wholeHouse.materialTemplate.osDateFilterFields,
	stageStatusFilterFields: [] as const,
	booleanFilterFields: [] as const,
});
